/** @flow */

import * as actions from "@modules/shared/constants/actions";
import * as absenceReasonsReducers from "./reducers";
import initialState from "./state";
import type { AbsenceReviewState } from "./types";
import { cloneObject } from "@utils/object";

export default (state: AbsenceReviewState = initialState, action: Object): Object => {
  const act = {
    [actions.GetLastAbsenceReviewTask]: absenceReasonsReducers.onGetLastAbsenceReviewTask,
    [actions.GetLastAbsenceReviewTaskSuccess]:
      absenceReasonsReducers.onGetLastAbsenceReviewTaskSuccess,
    [actions.GetLastAbsenceReviewTaskError]: absenceReasonsReducers.onGetLastAbsenceReviewTaskError,
    [actions.GetAbsenceReviewTask]: absenceReasonsReducers.onGetAbsenceReviewTask,
    [actions.GetAbsenceReviewTaskSuccess]: absenceReasonsReducers.onGetAbsenceReviewTaskSuccess,
    [actions.GetAbsenceReviewTaskError]: absenceReasonsReducers.onGetAbsenceReviewTaskError,
    [actions.GetReferralDecisionTaskData]: absenceReasonsReducers.onGetReferralDecisionTaskData,
    [actions.GetReferralDecisionTaskDataSuccess]:
      absenceReasonsReducers.onGetReferralDecisionTaskDataSuccess,
    [actions.CreateAbsenceReviewTask]: absenceReasonsReducers.onCreateAbsenceReviewTask,
    [actions.CreateAbsenceReviewTaskSuccess]:
      absenceReasonsReducers.onCreateAbsenceReviewTaskSuccess,
    [actions.CreateAbsenceReviewTaskError]: absenceReasonsReducers.onCreateAbsenceReviewTaskError,
    [actions.CancelAbsenceReviewTask]: absenceReasonsReducers.onCancelAbsenceReviewTask,
    [actions.CancelAbsenceReviewTaskSuccess]:
      absenceReasonsReducers.onCancelAbsenceReviewTaskSuccess,
    [actions.CancelAbsenceReviewTaskError]: absenceReasonsReducers.onCancelAbsenceReviewTaskError,
    [actions.SubmitAbsenceReviewTask]: absenceReasonsReducers.onSubmitAbsenceReviewTask,
    [actions.SubmitAbsenceReviewTaskSuccess]:
      absenceReasonsReducers.onSubmitAbsenceReviewTaskSuccess,
    [actions.SubmitAbsenceReviewTaskError]: absenceReasonsReducers.onSubmitAbsenceReviewTaskError,
  };

  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
